document.addEventListener('DOMContentLoaded', function () {
  var dropdowns = document.querySelectorAll('.site-header__nav-item.has-submenu');
  if (!dropdowns.length) return;

  function closeAll(except) {
    dropdowns.forEach(function (item) {
      if (item !== except) item.classList.remove('is-open');
    });
  }

  dropdowns.forEach(function (item) {
    var link = item.querySelector('a');
    if (!link) return;

    link.addEventListener('click', function (event) {
      event.preventDefault();
      var wasOpen = item.classList.contains('is-open');
      closeAll();
      if (!wasOpen) item.classList.add('is-open');
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.site-header__nav-item.has-submenu')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
});
